import { Typography } from '@mui/material';
import { RouteProps } from 'react-router-dom';

import DetailPanel from '../../../components/DetailPanel/DetailPanel';
import { FormBox } from '../../../components/DetailPanel/DetailPanel.styles';
import { ShadowBox } from './bankConnectionPanel.styles';
import PlaidLinkWithOAuth from './plaidLink';

interface Props extends RouteProps {
  showBankConnectionPanel: boolean;
  onBankConnectionClose: () => void;
}

export const BankConnectionPanel: React.FC<Props> = ({
  showBankConnectionPanel,
  onBankConnectionClose,
}: Props) => {
  return (
    <>
      <DetailPanel
        id="bank_connection_panel"
        title={'Connect Account'}
        open={showBankConnectionPanel}
        variant={'temporary'}
        hasTabsPanel={false}
        onClose={() => {
          onBankConnectionClose();
        }}
      >
        <FormBox>
          <ShadowBox>
            <div>
              <Typography>Explanation placeholder</Typography>
              <br></br>
              <Typography>May be redirected...</Typography>
              <br></br>
              <br></br>
              <Typography>
                Make sure all the accounts you want to import transactions from
                are selected
                <Typography>when you connect.</Typography>
              </Typography>
            </div>
          </ShadowBox>
          <PlaidLinkWithOAuth />
        </FormBox>
      </DetailPanel>
    </>
  );
};
